import { render, staticRenderFns } from "./app.vue?vue&type=template&id=3642a85e&scoped=true&"
import script from "./app.js?vue&type=script&lang=js&"
export * from "./app.js?vue&type=script&lang=js&"
import style0 from "./app.scss?vue&type=style&index=0&id=3642a85e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3642a85e",
  null
  
)

export default component.exports